import { Head } from "@inertiajs/react";
import AuthLayout from "@/layouts/auth-layout";
import ContentLibraryPdfPreview from "@/components/content-library-pdf-preview";
import { documents_path, edit_document_path, edit_guide_path, edit_template_path, guides_path, pdf_document_path, pdf_guide_path, pdf_template_path, templates_path } from "@/routes";

const configs = {
  template: { collectionPath: templates_path, editPath: edit_template_path, pdfPath: pdf_template_path },
  document: { collectionPath: documents_path, editPath: edit_document_path, pdfPath: pdf_document_path },
  guide: { collectionPath: guides_path, editPath: edit_guide_path, pdfPath: pdf_guide_path }
};

export default function ContentLibraryShow({ content_kind: contentKind, content_label: contentLabel, item, pdf_url: pdfUrl }) {
  const config = configs[contentKind] || configs.document;
  const pdfSource = pdfUrl || config.pdfPath(item.id);

  return (
    <>
      <Head title={item.name} />

      <section className="workspace-content content-library-show-page">
        <article className="content-library-show-paper">
          {item.is_text_document === false ? (
            <div className="alert alert-info mb-0">Dette dokument er et uploadet fil-dokument og har ikke en PDF-visning.</div>
          ) : (
            <ContentLibraryPdfPreview src={pdfSource} title={`${contentLabel}: ${item.name}`} />
          )}
        </article>
      </section>
    </>
  );
}

ContentLibraryShow.layout = (page) => {
  const { layout_header: layoutHeader } = page.props;
  const config = configs[page.props.content_kind] || configs.document;

  return (
    <AuthLayout
      header={{
        breadcrumbs: [
          { label: layoutHeader?.breadcrumb || "Bibliotek" },
          { label: layoutHeader?.title || "Vis" }
        ],
        title: layoutHeader?.title || "Vis",
        actions: [
          { href: config.collectionPath(), label: "Tilbage", variant: "outline-secondary" },
          ...(page.props.can_edit ? [{ href: config.editPath(page.props.item.id), label: "Redigér" }] : [])
        ]
      }}
    >
      {page}
    </AuthLayout>
  );
};
